"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoaderOverlay = void 0;
var react_1 = __importStar(require("react"));
var react_dom_1 = require("react-dom");
var themes_1 = require("../../../themes");
var LoaderCircle_1 = require("../LoaderCircle");
/**
 * @component Renders a loader overlay component with customizable text and styling.
 *
 * - The props object containing the following properties:
 * @prop {string} loaderText: The text to be displayed in the loader overlay.
 * @return {ReactElement} The rendered loader overlay component.
 */
var LoaderOverlay = function (_a) {
    var loaderText = _a.loaderText;
    return ((0, react_dom_1.createPortal)(react_1.default.createElement(react_1.Fragment, null,
        react_1.default.createElement("div", { style: {
                position: 'fixed',
                width: '100vw',
                height: '100vh',
                background: themes_1.colors.greyColor100,
                opacity: 0.8,
                top: 0,
                left: 0,
                zIndex: 1000000,
            } },
            react_1.default.createElement(LoaderCircle_1.LoaderCircle, { text: loaderText || "Generating Template...", isBlock: true, invert: true }))), document.getElementById("loader-root")));
};
exports.LoaderOverlay = LoaderOverlay;
